import * as _ from "lodash";
import {ESRecord} from "../lib/ESRecord";
import {utils, Schema, Record} from "js-data";
import {SimpleRecord} from "./SimpleRecord";
import {ExecutionSerializer} from "./ExecutionSerializer";



export class RecordAggregate<RecordTemplate extends Record>
  extends SimpleRecord {

  _recordSchema: Schema
  _dctRecords: {[id: number]: RecordTemplate} = {}
  _aggFields: string[]
  _pauseRefresh: boolean
  _idField: string
  _dctCalcTerms: {[id:string]: (aRow:any) => number} = {}
  _refreshTotals: ExecutionSerializer

  constructor(aSchema: Schema, aggrPropNames?: string[]){
    super()

    this._recordSchema = aSchema
    this._dctRecords = {}
    this._aggFields = []
    this._pauseRefresh = false
    this._idField = "unknown_id"
    this._dctCalcTerms = {}
    // Iterate over properties to determine _aggFields and _idField
    /* example property   { "SOURCEAPP_ID": {  "type": "number",  "id": true, "required": true },  */

    _.forEach(this._recordSchema.properties, (aProperty, fieldName) => {
      if(aProperty.id){
        this._idField = fieldName
      }

      if(fieldName.startsWith("WB_")){ return }

      if(fieldName.endsWith("_ID")){ return }

      if(aProperty.type == "number"){
        this._aggFields.push(fieldName)
      }

    })

    if(_.isArray(aggrPropNames)){
      _.forEach(aggrPropNames, (aFieldName:string) => {
        this._aggFields.push(aFieldName)
      })
    }

    this._refreshTotals = new ExecutionSerializer(this,
        this.refreshTotals_Async.bind(this),[{}],500, true)

  }

  addRecord(aRecord: RecordTemplate){

    if(_.isEmpty(aRecord)){ return }

    let key = (<any> aRecord)[this._idField]

    if(key in this._dctRecords){ return }

    _.forEach(this._aggFields, (aField) => {
      aRecord.on('change:' + aField,  this.onRecordPropertyChange, this)
    })

    this._dctRecords[key] = aRecord

    this.refreshTotals()
  }

  addCalcTerm(id: string, termFunction: (aRow: any) => number){
    this._dctCalcTerms[id] = termFunction
  }

  removeCalcTerm(id: string){
    delete this._dctCalcTerms[id]
  }

  // Event change handler
  onRecordPropertyChange(){
    // this.refreshTotals()
    this._refreshTotals.Run()
  }

  pauseRefreshTotals() {
    this._pauseRefresh = true
  }

  resumeRefreshTotals() {
    this._pauseRefresh = false
    this.refreshTotals()
  }

  refreshTotals(){
    if(this._pauseRefresh){ return}

    // Reaggregate columms
    let totals: {[id: string]: number} = {}

    _.forEach(this._aggFields, (aField) => {
      totals[aField] = 0
    })
    _.forEach(this._dctCalcTerms, (aggFunction, aField) => {
      totals[aField] = 0
    })


    _.forEach(_.values(this._dctRecords), (aRow:any) => {
      _.forEach(this._aggFields, (aField) => {
        totals[aField] = totals[aField] + _.toNumber((aRow[aField] || 0))
      })
      _.forEach(this._dctCalcTerms, (aggFunction, aField) => {
        totals[aField] = totals[aField] + _.toNumber(aggFunction(aRow))
      })
    })

    // Apply Changes to local record
    let thisAny: any = this
    _.forEach(this._aggFields, (aField) => {
      thisAny[aField] = totals[aField]
    })
    _.forEach(this._dctCalcTerms, (aggFunction, aField) => {
      thisAny[aField] = totals[aField]
    })


    // Notify Listeners to Changes
    _.forEach(this._aggFields, (aField) => {
      this.notify(aField, thisAny[aField])
    })

  }

  destroy(){
    // Unregister record listener
    _.forEach(_.values(this._dctRecords), (aRecord) => {
      _.forEach(this._aggFields, (aField) => {
        aRecord.off('change:' + aField,  this.onRecordPropertyChange)
      })
    })

    this._dctRecords = {}
    this._pauseRefresh = true
    this._dctCalcTerms = {}
  }

  async refreshTotals_Async(): Promise<void> {
    this.refreshTotals();    // call the sync version
  }

}

